<template>
  <div id="teaching_infors_outer">
    <teaching-view v-for="(item, index) in teachingList"
    :key="item.uuid"
    :item="item"
    :index="index"
    :noticed="showRedBorder"
    v-on:deleteItem="deleteTeachingItem"
     />

    <div style="margin-top: 30px;" ><a href="javascript:void(0)" @click="addNewTeachingItem">+添加更多履历</a></div>

    <div style="width: 100%;text-align: center;margin-top: 50px;">
      <el-button class="bottom-button back-button" @click="backButtonClicked" round>上一步</el-button>
      <el-button v-if="isAllField" class="bottom-button next-button" round @click="nextButtonClicked"> 下一步</el-button>
      <el-button v-else  class="bottom-button gray-button" round @click="noticeButtonClicked"> 下一步</el-button>
    </div>
  </div>
</template>

<script>
  import TeachingCardItem from "../cards/TeachingCardItem.vue";
  import DataCreator from "../../../../js/coach/data-creator.js";
  import EventManager from "../../../../js/event-common.js";
  import {Loading} from "element-ui";
	export default {
	  name: "AddCoachingsInformationVue",
    props: {
      coachItem: {
        type: Object,
        default: null,
      }
    },
    components: {
      TeachingView: TeachingCardItem
    },
	  data() {
	    return {
        teachingList: [],
        initialList: [],
        isAllField: false,
        isEdited: false,
        showRedBorder: false,
	    }
	  },
    computed: {
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
      eventManager() {
        return this.$store.state.eventManager;
      },
    },
    watch: {
      teachingList: {
        handler(val, oldVal) {
          this.isAllField = this.isDataAllFilled();
          console.log(this.isAllField);
          console.log(val);
          this.isDataEidted();
        },
        deep: true
      },
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        let resumes = this.coachItem.resumes;
        if (resumes == null || resumes.length == 0) {
          console.log('---1');
          let resumeData = DataCreator.methods.resume.getEmptyItem();
          resumeData.coachId = this.coachItem.coach.id;
          let model = DataCreator.methods.resume.getModelFromItem(resumeData);
          this.teachingList.push(model);
          let copiedModel = DataCreator.tools.deepCopy(model);
          this.initialList.push(copiedModel);
        } else {
          for (let i = 0; i < resumes.length; i++) {
            let item = resumes[i];
            let model = DataCreator.methods.resume.getModelFromItem(item);
            this.teachingList.push(model);
            let copiedModel = DataCreator.tools.deepCopy(model);
            this.initialList.push(copiedModel);
          }
        }
      },

      isItemAllFilled(item) {
        if (item == undefined || item == null) {
          return false;
        }
        let allFilled = true;
        for(let key in item) {
          let value = item[key];
          if (key == 'photos' || key == 'results' || key == 'id' || key == 'strEndDate') {
            continue;
          } else {
            if (value == null || value == '') {
              allFilled = false;
              break;
            }
          }
        }
        return allFilled;
      },

      isDataAllFilled() {
        let teachingList = this.teachingList;
        let allFilled = true;
        for (let i = 0; i < teachingList.length; i++) {
          let item = teachingList[i];
          let isFilled = this.isItemAllFilled(item);
          if (!isFilled) {
            allFilled = false;
            break;
          }
        }
        return allFilled;
      },

      isDataEidted() {
        let isEdited = !DataCreator.tools.isDeepEqualed(this.teachingList, this.initialList);
        if (this.isEdited == isEdited) {
          return;
        }
        this.isEdited = isEdited;
        let allowedLeave = !this.$store.state.allowedLeave;
        if (allowedLeave != isEdited) {
          this.$store.commit('isAllowedLeave', !isEdited);
        }
        console.log('数据是否改变：' + this.isEdited);
      },

      deleteTeachingItem(res) {
        console.log(res);
        let index = res.index;
        this.teachingList.splice(index, 1)
      },
      addNewTeachingItem() {
        let emptyData = DataCreator.methods.resume.getEmptyItem();
        emptyData.coachId = this.coachItem.coach.id;
        let model = DataCreator.methods.resume.getModelFromItem(emptyData);
        this.teachingList.push(model);
      },

      updateStatus(status, success, failure) {
        let params = {};
        let coachItem = this.coachItem;
        params.status = status;
        params.auditStatus = 1;
        params.id = coachItem.coach.id;
        this.httpManager.ajax.postCoachStatusUpdateRequest(params, function(data) {
          console.log(data);
          console.log('upate coach status succeed!');
          let code = data.code;
          if (code == 0) {
            success();
            return;
          }
          failure(data);
        }, function(data) {
          failure(data);
        });
      },

      backButtonClicked() {
        if (this.isEdited) {
          let _this = this;
          this.$confirm('当前页面已经修改，是否放弃修改？', '提示', {
            confirmButtonText: '放弃',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            _this.$store.commit('isAllowedLeave', true);
            _this.$emit('back');
          }).catch(() => {
            //...
          })
        } else {
          this.$emit('back');
        }
      },

      noticeButtonClicked() {
        let teachingList = this.teachingList;
        if (teachingList == null || teachingList.length == 0) {
          return;
        }
        let unCheckedList = ['id', 'uuid', 'coachId', 'strEndDate', 'results', 'photos'];
        OutLoop:
        for(let i = 0; i < teachingList.length; i++) {
          let model = teachingList[i];
          for(let key in model) {
            if (unCheckedList.indexOf(key) >= 0) {
              continue;
            }
            let value = model[key];
            let isEmpty = false;
            if (!value) {
              isEmpty = true;
            }
            if (isEmpty) {
              let viewId = 'resume_' + model.uuid + '_' + key + '_view';
              // console.log(viewId);
              this.showRedBorder = true;
              document.getElementById(viewId).scrollIntoView(true);
              break OutLoop;
            }
          }
        }
      },

      nextButtonClicked() {
        if (!this.isEdited && this.teachingList[0].id > 0) { // 未修改的话，不用上传数据
          this.$emit("next");
          return;
        }

        let params = [];
        for(let i = 0; i < this.teachingList.length; i++) {
          let certItem = this.teachingList[i];
          let item = {};
          for (let key in certItem) {
            if (key == 'uuid') {
              continue;
            }
            if (key == 'photos') {
              let list = certItem[key];
              let photo = "";
              for(let j = 0; j < list.length; j++) {
                let picture = list[j];
                photo += picture.url;
                if (j < list.length - 1) {
                  photo += ",";
                }
              }
              item['photo'] = photo;
            } else {
              item[key] = certItem[key];
            }
          }
          params.push(item);
        }
        console.log(params);

        let _this = this;
        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        this.httpManager.ajax.postCoachEditResumesRequest(params, function(data) {
           console.log('upload resume list success');
           console.log(data);
           let code = data.code;
           if (code == 0) {
              _this.updateStatus(3, function() {
                loadFlags.close();
                console.log('update status succeed!');
                _this.eventManager.postNotification(EventManager.notificationNameObject.updateCoachData, null);
                _this.isEdited = false;
                _this.$store.commit('isAllowedLeave', true);
              }, function(data) {
                console.log('update status failed!');
                _this.$toast("保存失败！");
              });
             return;
           }
           loadFlags.close();
           _this.$toast("保存失败！");
        }, function(data) {
          loadFlags.close();
          _this.$toast("保存失败，请重试！");
        });

      }
    }
	}
</script>

<style scoped>
  @import url("../../../../css/back-next-buttons.css");
  #teaching_infors_outer {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/children/AddCoachingsInformation.vue